module.exports = __webpack_public_path__ + "img/interior_panel.46a79c5a.jpg";